export const goodreadsUrl =
    "https://www.goodreads.com/review/list/171804417";

export const hobbies = [
    {
        id: "ajedrez",
        emoji: "♟️",
        title: "Ajedrez",
        description:
            "Me ayuda a pensar por adelantado, calcular variantes y mantener la calma bajo presión.",
    },
    {
        id: "lectura",
        emoji: "📚",
        title: "Lectura",
        description:
            "Libros técnicos y de otros temas para seguir aprendiendo y ampliar la perspectiva.",
    },
    {
        id: "play",
        emoji: "🎮",
        title: "PlayStation",
        description:
            "Desconectar jugando a la Play; una buena partida es mi forma de recargar energías.",
    },
];

export const booksReadCount = 71;

// Selección curada desde Goodreads (estantería "read"): tech / ajedrez.
export const books = [
    { id: "book-1", title: "Clean Code", author: "Robert C. Martin" },
    { id: "book-2", title: "Nexus", author: "Yuval Noah Harari" },
    { id: "book-3", title: "Hábitos atómicos", author: "James Clear" },
];
